import React from 'react';

export default function generateCustomIcon(SvgContent: any, { viewBox }: any) {
  return class extends React.Component<any> {
    static isCustom = true;

    static defaultProps = {
      color: 'currentColor',
      height: '1em',
      width: '1em',
    };

    render() {
      const { height, width, size, color, className, onClick, style } = this.props;

      const _width = size || width;
      const _height = size || height;

      return (
        <svg
          viewBox={typeof viewBox === 'string' ? viewBox : `0 0 ${viewBox} ${viewBox}`}
          xmlnsXlink="http://www.w3.org/1999/xlink"
          className={`svg-inline--custom svg-inline--fa ${className || ''}`}
          fill={color}
          onClick={onClick}
          style={{
            width: _width,
            height: _height,
            ...(style || {}),
          }}
        >
          <SvgContent {...this.props} />
        </svg>
      );
    }
  };
}
